import { RoutesEnum } from '@/routes/Routes.enum.ts';
import { useMobileMediaQuery } from '@/utils/useMobileMediaQuery.ts';
import InactiveMessageDesktop from '@/views/inactive/components/InactiveMessageDesktop.tsx';
import InactiveMessageMobile from '@/views/inactive/components/InactiveMessageMobile.tsx';
import { useNavigate } from 'react-router-dom';

const InactiveView: React.FC = () => {
  const isMobile = useMobileMediaQuery();
  const navigate = useNavigate();

  const handleBack = (event: React.FormEvent) => {
    event.preventDefault();
    navigate(RoutesEnum.ROOT);
  };

  return isMobile ? (
    <InactiveMessageMobile handleBack={handleBack} />
  ) : (
    <InactiveMessageDesktop handleBack={handleBack} />
  );
};

export default InactiveView;
